import { Angulartics2 } from '@angularticsCompat';

import { ACTIVATION_SESSION_ID_KEY } from '../constants/constants';
import { SessionTrackingAngularticsService } from './session-tracking-angulartics.service';
import { SettingsStorageService } from '../../auth/services/settings-storage.service';


export class CreateActivateAngularticsService extends SessionTrackingAngularticsService {
  static deps = [
    Angulartics2,
    SettingsStorageService
  ];

  constructor(
    protected _angulartics2: Angulartics2,
    protected _settingsStorageService: SettingsStorageService
  ) {
    super(
      _angulartics2,
      _settingsStorageService,
      ACTIVATION_SESSION_ID_KEY
    );
  }
}
